module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-2560-0a5929f89e586d253d0df3a8e58add33.webp";